import { render, staticRenderFns } from "./InvestPostList.vue?vue&type=template&id=3182b8f5&scoped=true&"
import script from "./InvestPostList.vue?vue&type=script&lang=js&"
export * from "./InvestPostList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3182b8f5",
  null
  
)

export default component.exports